let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5p6PW")).then(() => parcelRequire('cyXr6'));